const setMenu = menu => ({
  type: "SET_MENU",
  menu,
});

export default setMenu;
